/**
 * StyleX styles for admin users components.
 */

import * as stylex from "@stylexjs/stylex";

export const styles = stylex.create({
  field: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  statusActive: {
    color: "#4ade80",
  },
  statusBanned: {
    color: "#f87171",
  },
});
